var jade = require("/app/app/assets/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"btn-group btn-group-xs\"><button ng-click=\"$ctrl.handleClickLeft()\" ng-class=\"$ctrl.isLeftOn ? &quot;btn-success&quot; : &quot;btn-default&quot;\" class=\"btn\"><div ng-transclude=\"left\">{{$ctrl.leftValue}}</div></button><button ng-click=\"$ctrl.handleClickRight()\" ng-class=\"$ctrl.isRightOn ? &quot;btn-danger&quot; : &quot;btn-default&quot;\" class=\"btn\"><div ng-transclude=\"right\">{{$ctrl.rightValue}}</div></button></div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./javascripts/common/components/od-three-state-switch.jade
 ** module id = 694
 ** module chunks = 0 1 3 4 5 6
 **/